"use_strict";

const xtcdpncdnvhaeafveqkdfkevtndwnwat =
{
    values:
    {
        "instructions": 
        [
            {  "id": "i_op_r_remove" , "text_id": "r_remove_1" , "step": "remove" }
            ,
            { "id": "i_op_r_wash"   , "text_id": "r_wash_1"   , "step": "wash"   }
            ,
            { "id": "i_op_r_grind"  , "text_id": "r_grind_1"  , "step": "grind"  }
            ,
            { "id": "i_op_r_prime"  , "text_id": "r_prime_1"  , "step": "prime"  }
            ,
            { "id": "i_op_r_apply"  , "text_id": "r_apply_1"  , "step": "apply"  }
            ,
            { "id": "i_op_g_remove" , "text_id": "g_remove_1" , "step": "remove" }
            ,
            { "id": "i_op_g_wash"   , "text_id": "g_wash_1"   , "step": "wash"   }
            ,
            { "id": "i_op_g_grind"  , "text_id": "g_grind_1"  , "step": "grind"  }
            ,
            { "id": "i_op_g_prime"  , "text_id": "g_prime_1"  , "step": "prime"  }
            ,
            { "id": "i_op_g_apply"  , "text_id": "g_apply_1"  , "step": "apply"  }
            ,
            { "id": "i_op_b_remove" , "text_id": "b_remove_1" , "step": "remove" }
            ,
            { "id": "i_op_b_wash"   , "text_id": "b_wash_1"   , "step": "wash"   }
            ,
            { "id": "i_op_b_grind"  , "text_id": "b_grind_1"  , "step": "grind"  }
            ,
            { "id": "i_op_b_prime"  , "text_id": "b_prime_1"  , "step": "prime"  }
            ,
            { "id": "i_op_b_apply"  , "text_id": "b_apply_1"  , "step": "apply"  }
            ,
            { "id": "i_op_y_remove" , "text_id": "y_remove_1" , "step": "remove" }
            ,
            { "id": "i_op_y_wash"   , "text_id": "y_wash_1"   , "step": "wash"   }
            ,
            { "id": "i_op_y_grind"  , "text_id": "y_grind_1"  , "step": "grind"  }
            ,
            { "id": "i_op_y_prime"  , "text_id": "y_prime_1"  , "step": "prime"  }
            ,
            { "id": "i_op_y_apply"  , "text_id": "y_apply_1"  , "step": "apply"  }
            ,
            { "id": "i_4layersPrimer117"                     
                ,"text_id": ["i_4layersPrimer117" ]
                ,"product_id":"pri117"
                ,"value":4
                ,"step":"prime"
            }
            ,
            { "id": "i_biozidfreie_beschichtung_auftragen"   
                ,"text_id": ["i_biozidfreie_beschichtung_auftragen" ]
                ,"step":"apply"   
            }
            ,
            { "id": "i_TieCoat"                              
                ,"text_id": ["i_TieCoat" ]
                ,"product_id":"priTC"
                ,"step":"prime"   
            }
            ,
            { "id": "i_BioCleanEco"                          
                ,"text_id": ["i_BioCleanEco" ]
                ,"step":"apply"   
            }
            ,
            { "id": "i_altes_antifouling_komplett_entfernen" 
                ,"text_id": ["i_altes_antifouling_komplett_entfernen" ]
                ,"step":"remove"   
            }
            ,
            { "id": "i_schleim_entfernen"                    
                ,"text_id": ["i_schleim_entfernen" ]
                ,"step":"wash"   
            }
            ,
            { "id": "i_anschleifen"                          
                ,"text_id": ["i_anschleifen" ]
                ,"step":"grind"   
            }
            ,
            { "id": "i_nochmal_waschen"                      
                ,"text_id": ["i_nochmal_waschen" ]
                ,"step":"grind"   
            }
            ,
            { "id": "i_1layerPrimer015"                      
                ,"text_id": ["i_1layerPrimer015" ]
				,"product_id":"pri015"
                ,"step":"prime"   
				,"value":1
            }
            ,
            { "id": "i_apply_antifouling"                    
                ,"text_id": ["i_apply_antifouling" ]
                ,"step":"apply"   
            }
            ,
            { "id": "i_2layersTieCoat"                       
                ,"text_id": ["i_2layersTieCoat" ]
                ,"step":"prime"   
				,"product_id":"priTC"
                ,"value": 2   
            }
            ,
            { "id": "i_2layersBCE"                           
                ,"text_id": ["i_2layersBCE" ]
                ,"step":"apply"
				,"product_id":"pBCE"
                ,"value": 2   
            }
            ,
            { "id": "i_allgemein_A_1"                          
                ,"text_id": ["i_allgemein_A_1"]
                ,"step":"apply"
                ,"value": 2
            }
            ,
            { "id": "i_allgemein_A_2"                          
                ,"text_id": ["i_allgemein_A_2"]
                ,"step":"apply"   
            }
            ,
            { "id": "i_allgemein_A_3"                          
                ,"text_id": ["i_allgemein_A_3"]
                ,"step":"apply"   
            }
            ,
            { "id": "i_allgemein_B_prime"                          
                ,"text_id": ["i_allgemein_B_1" ]
                ,"step":"prime"
                ,"product_id":"priTC"
                ,"value":2
            }
            ,
            { "id": "i_allgemein_B_apply"                          
                ,"text_id": ["i_allgemein_B_2","i_allgemein_B_3" ]
                ,"step":"apply"   
                ,"value":2
            }
        ],
    }
}

// @ts-ignore
window.xtcdpncdnvhaeafveqkdfkevtndwnwat = xtcdpncdnvhaeafveqkdfkevtndwnwat;
